import styled, { css } from 'styled-components'
import { v1 as color, media, contentLevels } from 'sidecar-design-library'

import BaseIcon from '../IconV1'

const flushStyles = css`
  ${p => p.fullBleed && `padding: 0;`}
  ${p => p.flushTop && `padding-top: 0;`}
  ${p => p.flushRight && `padding-right: 0;`}
  ${p => p.flushBottom && `padding-bottom: 0;`}
  ${p => p.flushLeft && `padding-left: 0;`}
`

export const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: ${p => (p.rightMargin ? p.rightMargin : 0)};
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0px;
  display: none;
  animation: 0.2s modalFadeIn;

  // the z-index domain of modals and toast messages is
  // 300 and up (the highest of all). Modals are slightly
  // less relevant than a brand new notification, so they
  // should display behind toasts and be at the bottom of
  // this domain.
  z-index: ${contentLevels.modals};

  @keyframes modalFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  ${p => p.isOpen && `display: flex;`}

  ${media.mobileAndBelow`
    padding: 0.625rem;
  `}
`

export const ModalHeader = styled.div`
  margin: 0;
  padding: 2.5rem 2.5rem 1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${media.mobileAndBelow`
    padding: 1.25rem;
  `}
`

export const ModalTitle = styled.h1`
  margin: 0;
  padding: 0;
  flex-grow: 1;
  word-break: break-word;
`

export const ModalActions = styled.div`
  flex-shrink: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: 1.25rem;
  padding-top: 0.5rem;
`

export const CloseButton = styled(BaseIcon).attrs({
  name: 'x',
})`
  display: flex;
  justify-content: center;
  align-items: center;
  // TODO: change to fill once we're using icon v2 (since they are svgs)
  color: ${color.AQUAMARINE};
  font-size: 1.5625rem;
  cursor: pointer;

  &:hover {
    // TODO: change to fill once we're using icon v2 (since they are svgs)
    color: ${color.SCOOTER};
  }
`

export const ModalBody = styled.div`
  padding: 2.5rem;
  ${flushStyles}

  ${media.mobileAndBelow`
    padding: 1.25rem;
    ${flushStyles}
  `}
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 2.5rem 2.5rem;
  ${flushStyles}

  ${media.mobileAndBelow`
    padding: 0 1.25rem 1.25rem;
    ${flushStyles}
  `}
`

export const ModalDialog = styled.div`
  margin: auto;
  background: white;
  position: relative;
  display: none;
  min-width: 100px;
  max-width:  40.625rem;
  ${p => p.isOpen && `display: block;`}

  // we use +1 here to always be above the background
  z-index: ${contentLevels.modals + 1};
  
  ${p =>
    p.wide &&
    `
    max-width:  62.5rem;
    width:  62.5rem;
  `}

  ${media.belowTablet`
    width: 100%;
  `}

  ${ModalHeader} {
    ${p =>
      p.slim &&
      `
      padding: 1.25rem 1.25rem 0.625rem;
      font-family: 'sidecarta-sans-bold', sans-serif;
    `}
  }

  ${ModalTitle} {
    ${p =>
      p.slim &&
      `
      font-size: 1.5rem;
      line-height: 1.875rem;
      color: #000;
      font-family: 'sidecarta-sans-bold', sans-serif;
    `}
  }

  ${ModalActions} {
    ${p =>
      p.slim &&
      `
      padding-top: 0.1875rem;
    `}
  }

  ${ModalHeader} + ${ModalBody} {
    padding-top 0;

    ${p =>
      p.slim &&
      `
      padding: 0 1.25rem 1.25rem;
    `}
  }

  ${ModalBody} {
    ${p =>
      p.slim &&
      `
      padding: 1.25rem;
    `}
  }

  ${CloseButton} {
    ${p =>
      p.slim &&
      `
      font-size: 0.9375rem;
    `}
  }

  ${ModalFooter} {
    ${p =>
      p.slim &&
      `
      padding: 0 1.25rem 1.25rem;
    `}
  }

  animation: 0.2s fadeInAndEnlarge;
  @keyframes fadeInAndEnlarge {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`
